import dayjs from "dayjs";

/**
 * True when the trade window ends before it starts — or, with no start, before
 * now, since a blank start means "now". `undefined` when there is no end to
 * check.
 */
export const tradeEndBeforeStart = (
  start: dayjs.Dayjs | undefined,
  end: dayjs.Dayjs | undefined
): boolean | undefined => {
  if (!end) {
    return undefined;
  }
  return end.isBefore(start ?? dayjs());
};

export const formatRuntime = (
  start?: dayjs.Dayjs | string,
  end?: dayjs.Dayjs | string
) => {
  const start_d = dayjs(start);
  const end_d = dayjs(end);

  const daysDiff = end_d.startOf("day").diff(start_d.startOf("day"), "day");

  const endDateIndicator = daysDiff > 0 ? `${end_d.format("D/M")}` : "";
  const startDateIndicator = daysDiff > 0 ? `${start_d.format("D/M")}` : "";

  if (!end_d) {
    return "N/A";
  } else if (start && end) {
    return `${startDateIndicator} ${start_d.format(
      "HH:mm"
    )} - ${endDateIndicator} ${end_d.format("HH:mm")}`;
  } else {
    return "N/A";
  }
};
